import axios from "axios";
import { ALL_CLIENTS_KEY, useOrgStore } from "../stores/org.store";

declare global {
  interface Window {
    __PORTAL_FORBIDDEN__?: boolean;
  }
}

const rawUrl = import.meta.env.VITE_API_URL;
const baseURL = rawUrl ? `${rawUrl.replace(/\/+$/, "")}/api` : "/api";

export const api = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
});

let getTokenFn: (() => Promise<string | null>) | null = null;



export const setClerkTokenGetter = (fn: () => Promise<string | null>) => {
  getTokenFn = fn;
}

let signOutFn: (() => Promise<void>) | null = null;



export const setClerkSignOut = (fn: () => Promise<void>) => {
  signOutFn = fn;
}

api.interceptors.request.use(async (config) => {
  if (getTokenFn) {
    const token = await getTokenFn();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  const activeClientId = useOrgStore.getState().activeClientId;
  if (activeClientId && activeClientId !== ALL_CLIENTS_KEY) {
    config.headers["X-Portal-Client-Id"] = activeClientId;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 403) {
      const msg = error.response?.data?.message ?? "";
      if (msg.includes("professionnel")) {
        window.__PORTAL_FORBIDDEN__ = true;
        if (signOutFn) await signOutFn();
      }
    }
    return Promise.reject(error);
  },
);
